<style lang="scss" scoped>
.schools {
	& ::v-deep .el-select {
		width: 100%;
	}
	&__container {
		@include container;
	}
	&__panel {
		@include main-panel;
	}
	&__header {
		@include flex-center;
		&__options {
			margin-left: auto;
		}
	}
	&__footer {
		@include main-panel-footer;
		&__right {
			margin-left: auto;
		}
	}
	&__warning {
		color: red;
		font-size: 20px;
		padding-top: 7px;
	}
	&__table {
		td,
		th {
			&:first-child {
				padding-left: 40px !important;
			}
			&:last-child {
				padding-right: 40px;
			}
		}
		tbody tr{
			cursor: pointer;
		}
		&__missing-item {
			display: inline-block;
			padding-left: 10px;
			color: red;
			font-size: 16px;
			vertical-align: middle;
		}
	}

}

</style>
<template lang="pug">
	div
		.schools()
			app-header
				.schools__header(slot="header")
					h1 Schools
			.schools__container
				.schools__panel
					loading(v-if="$apollo.loading")
					template(v-else)
						result-filter.ml-auto.mr-2(v-model="filters", :filter-fields="fields", :remember="true")
						table.table.schools__table
							thead
								tr
									th School
									th Postcode
									th URN
							tbody
								tr(v-for='(row, index) in paginated', @click='rowClicked(row)', :key='index')
									td {{ row.name }}
									td {{ row.address_postcode }}
									td {{ row.urn }}

						.schools__footer
							.schools__footer__left
								el-pagination(background="", layout="prev, pager, next", :current-page.sync="page", :page-size="per_page", :total="filtered.length")
							.schools__footer__right 
								| Showing
								strong &nbsp;{{ paginated.length }}
								| &nbsp;out of a possible
								strong &nbsp;{{ filtered.length }}
								| &nbsp;results
		<router-view></router-view>
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
import { onLogin } from "../../vue-apollo";
import provider from '../../libs/provider';
import Bugsnag from "@bugsnag/js";
export default {
	data() {
		return {
			page: 1,
			per_page: 50,
			filters: null,
			fields: [
				{
					name: "Name",
					path: "name",
					type: "text",
				}
			],
			orgSchools: [],
			hasError: false,
		};
	},

	computed: {
		filtered() {
			let filtered = this.orgSchools;
			if (this.orgSchools && this.filters) {
				if (this.filters.name) {
					filtered = _.filter(filtered, row => {
						return this.filters.name.filter_type == 'starts_with' ? _.startsWith(row.name.toLowerCase(), this.filters.name.value.toLowerCase()) : row.name.toLowerCase().includes(this.filters.name.value.toLowerCase());
					});
				}
				if (this.filters.status) {
					filtered = _.filter(filtered, (row) => {
						return this.filters.address_postcode.filter_type == 'starts_with' ? _.startsWith(row.address_postcode.toLowerCase(), this.filters.address_postcode.value.toLowerCase()) : row.address_postcode.toLowerCase().includes(this.filters.address_postcode.value.toLowerCase());
					});
				}
			}

			return filtered;
		},

		paginated() {
			let page = _.chunk(this.filtered, this.per_page)[this.page - 1];

			return page ? page : [];
		},
	},

	methods: {
		async rowClicked(row) {
			if (!await this.isSchoolApproved(parseFloat(row.id))) {
				this.$message.error("The school is not connected to Edusync " + provider.get().providerName);
				return;
			}

			this.$apollo
			.mutate({
				mutation: gql`
					mutation SwitchSchool($schoolId: Float!) {
						SwitchSchool(school_id: $schoolId)
					}
				`,
				variables: {
					schoolId: parseFloat(row.id)
				},
				update: (store, data) => {
					onLogin(this.$apollo.vm.$apolloProvider.clients.defaultClient, data.data.SwitchSchool);
					this.$router.push({ name: "directory" });
				}
			})
			.catch(e => {
				console.log(e);
			});
		},

		async isSchoolApproved(schoolId) {
			const data = await this.$apollo.query({
				query: gql`
					query HasSchoolConnection($schoolId: Float!) {
						HasSchoolConnection(school_id: $schoolId)
					}
				`,
				variables: {
					schoolId
				},
				fetchPolicy: "network-only"
			});
			
			return data.data.HasSchoolConnection || false;
		}
	},

	apollo: {
		// SP Provider Data
		orgSchools: {
			query: gql`
				query SchoolsForOrganisation {
					SchoolsForOrganisation {
						name
						address_postcode
						urn
						id
					}
				}
			`,
			fetchPolicy: "no-cache",
			update(r) {
				return r.SchoolsForOrganisation;
			},
			error(error) {
				Bugsnag.notify(error);
				this.$message.error("Failed to fetch organisation schools");
				hasError = true;
			},
			skip() {
				return this.hasError;
			}
		}
	}
};
</script>
